module.exports = __webpack_public_path__ + "static/minersharder-03a9d9723262dfe6dc8e3b7d76557164.svg";